export { default } from './BaseTable';
